var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-round__tooltip" }, [
    _c(
      "a",
      {
        staticClass: "btn--option",
        on: {
          click: function($event) {
            return _vm.print()
          }
        }
      },
      [
        _c("i", { staticClass: "glicon-f-print" }),
        _c("Tooltip", { attrs: { text: "tables.printBtn" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }